<script>
import { defineComponent } from 'vue'
import { Head } from '@inertiajs/vue3'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue"
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue"
import InfoCards from "@js/components/InfoCards/Components/InfoCards.vue"
import PartnershipLayout from "@js/Shared/PartnershipLayout.vue"
import { useCallbackStore } from "@js/store/CallbackStore.js"
import FaqComponent from "@js/components/Faq/FaqComponent.vue"

import shield_svg from '@img/guarantee/shield.svg'
import star_svg from '@img/guarantee/star.svg'
import clock_svg from '@img/guarantee/clock.svg'
import money_svg from '@img/guarantee/money.svg'
import delivery_svg from '@img/guarantee/delivery.svg'
import certificate_svg from '@img/guarantee/certificate.svg'

export default defineComponent({
    layout: PartnershipLayout,
    name: "B2BForInstallationOrganizationsPage",
    components: { Head, InfoCards, Breadcrumbs, MobileTopBar, FaqComponent },
    data() {
        return {
            // Преимущества для монтажных организаций
            items_group_1: [
                {
                    logo: shield_svg,
                    title: 'ГОСТ/ТУ и контроль марок стали',
                    description: 'Двутавр, швеллер, балки, профильные/круглые трубы, лист/профнастил, уголок — подтверждаем марочность и прокатку документально.',
                },
                {
                    logo: certificate_svg,
                    title: 'Паспорта качества и прослеживаемость',
                    description: 'Передаём МК/сертификаты завода. В закрывающих указываем партии/плавки и спецификацию — удобно для технадзора и генподрядчика.',
                },
                {
                    logo: clock_svg,
                    title: 'Оперативные отгрузки со склада',
                    description: 'При наличии — отгрузка день-в-день. Планируем поставки под окна монтажа, чтобы бригады не простаивали.',
                },
            ],
            items_group_2: [
                {
                    logo: money_svg,
                    title: 'НДС, ЭДО и возможная отсрочка',
                    description: 'Полный пакет документов. Электронный документооборот. Отсрочка — по договору и кредитной оценке.',
                },
                {
                    logo: delivery_svg,
                    title: 'Доставка прямо на площадку',
                    description: 'Манипуляторы/длинномеры, согласование тайм-слотов и пропусков, аккуратная разгрузка с учётом ППР и ТБ.',
                },
                {
                    logo: star_svg,
                    title: 'Спецусловия под регулярные закупки',
                    description: 'Индивидуальные цены, квоты и фиксация стоимости на согласованный период под график СМР.',
                },
            ],

            // SEO-FAQ (5 вопросов)
            faqItems: [
                {
                    question: 'Что поставляете для монтажных компаний?',
                    answer: `<p>Комплексный <strong>металлопрокат для монтажа</strong>: <strong>двутавры/балки</strong>, <strong>швеллер</strong>, <strong>уголок</strong>, <strong>профильные и круглые трубы</strong>, <strong>лист/профнастил</strong>, полоса/квадрат по запросу. Подбираем сечения под нагрузки и проектную ведомость.</p>`
                },
                {
                    question: 'Делаете резку в размер и маркировку мест?',
                    answer: `<p>Да. <strong>Резка лентой/газом/плазмой</strong> по чертежам и картам раскроя, <strong>комплектовка узлами/этажами/осями</strong>, маркировка мест и <strong>упаковочные листы</strong> — ускоряем монтаж и снижаем ошибки на площадке.</p>`
                },
                {
                    question: 'Как быстро доставляете и можно ли на стройку?',
                    answer: `<p>При складской доступности — <strong>день-в-день</strong> по Москве/МО. Доставляем <strong>манипулятором/длинномером</strong>, согласуем <strong>тайм-слоты и пропуска</strong>, учитываем подъездные пути и требования разгрузки.</p>`
                },
                {
                    question: 'Есть НДС/ЭДО, отсрочка и фиксация цены?',
                    answer: `<p>Да, работаем с <strong>НДС</strong>, поддерживаем <strong>ЭДО</strong>. <strong>Отсрочка</strong> — по договору. По заявке <strong>фиксируем цену</strong> на 1–3 дня либо на согласованный срок под график поставок.</p>`
                },
                {
                    question: 'Смешанные партии и дозаказы по объекту — возможно?',
                    answer: `<p>Да. Смешанные спецификации (арматура, балки/двутавры, трубы, лист/профнастил) комплектуем под проект. <strong>Экспресс-дозаказы</strong> согласуем индивидуально, чтобы не останавливать монтаж.</p>`
                },
            ],
        }
    },
    methods: {
        openForm() {
            this.callbackStore.showBaseCallbackPopup({
                title: 'Запросить КП для монтажных работ',
                bitrix_title: 'Заявка на партнёрство (монтажные организации • металлопрокат)',
            })
        }
    },
    setup() {
        const callbackStore = useCallbackStore()
        return { callbackStore }
    }
})
</script>

<template>
    <div>
        <div class="bg-black pt-5 md:pt-10 pb-[150px] text-white">
            <div class="container">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
                    <div class="flex items-center justify-center">
                        <div>
                            <Breadcrumbs class="text-white" color="#ffcf33"/>
                            <h1 class="text-2xl md:text-4xl font-bold mb-5 mt-5">
                                B2B-решения для монтажных компаний
                            </h1>
                            <p class="md:text-xl mb-5 md:max-w-[80%]">
                                Металлопрокат под монтаж: двутавры, швеллер, балки, профильные/круглые трубы, лист и профнастил. Резка в размер, комплектовка узлами/этажами и доставка прямо на площадку.
                            </p>
                            <button
                                @click.prevent="openForm"
                                class="flex max-md:w-full justify-center items-center text-black md:hover:text-baseYellow border-2 border-baseYellow bg-baseYellow md:hover:bg-transparent font-bold rounded-lg text-sm px-14 py-2.5 focus:outline-none transition cursor-pointer uppercase"
                            >
                                Запросить КП
                            </button>
                        </div>
                    </div>
                    <div class="flex items-center justify-center max-md:hidden">
                        <img
                            src="@img/b2b/installers/top-bg.webp"
                            class="max-h-[500px] rounded-full aspect-square object-cover"
                            alt="Металлопрокат для монтажных организаций"
                            title="Поставки металлопроката для монтажных компаний"
                        />
                    </div>
                </div>
            </div>
        </div>
        <section class="bg-white rounded-t-[25px] md:rounded-t-[50px] -mt-[100px] md:mb-20">
            <div class="container pt-10 md:pt-20">
                <div class="grid grid-cols-1 gap-5">
                    <div class="bg-grayBg p-5 md:p-7 rounded-lg md:rounded-2xl">
                        <h3 class="text-xl md:text-2xl font-bold mb-3">
                            Металлопрокат для монтажных организаций — Москва и МО (доставка по РФ по запросу)
                        </h3>
                        <p class="mb-3">
                            Снабжаем объекты «под ключ»: <strong>двутавры/балки</strong>, <strong>швеллер</strong>, <strong>уголок</strong>, <strong>профильные и круглые трубы</strong>, <strong>лист/профнастил</strong>.
                            Обеспечиваем <strong>резку в размер</strong>, <strong>комплектовку узлами/этажами/осями</strong>, маркировку мест и <strong>доставку на площадку</strong>.
                        </p>
                        <p class="mb-3">
                            Поставки по <strong>ГОСТ/ТУ</strong> с паспортами качества и прослеживаемостью. Для регулярных закупок — <strong>спецусловия</strong> и <strong>фиксация цены</strong>;
                            работаем с <strong>НДС</strong>, поддерживаем <strong>ЭДО</strong>, возможна <strong>отсрочка</strong>. При наличии на складе — <strong>отгрузка день-в-день</strong>.
                        </p>
                        <ul class="list-disc list-outside space-y-2 ps-5 font-medium">
                            <li>маркировка мест и упаковочные листы — ускоряем монтаж;</li>
                            <li>согласование тайм-слотов/пропусков, учёт подъездных путей;</li>
                            <li>экспресс-дозаказы под ход работ, фиксация цены на 1–3 дня.</li>
                        </ul>
                    </div>
                    <div>
                        <div class="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5 h-full">
                            <div class="flex flex-col items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-sm md:text-base lg:text-lg">
                                <p>Резка в размер по картам/чертежам</p>
                            </div>
                            <div class="flex flex-col items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-sm md:text-base lg:text-lg">
                                <p>Комплектовка узлами/этажами/осями</p>
                            </div>
                            <div class="flex flex-col items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-sm md:text-base lg:text-lg">
                                <p>Отгрузка день-в-день при наличии</p>
                            </div>
                            <div class="flex flex-col items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-sm md:text-base lg:text-lg">
                                <p>Доставка манипулятором/длинномером</p>
                            </div>
                            <div class="flex flex-col items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-sm md:text-base lg:text-lg">
                                <p>Документы с НДС, ЭДО, отсрочка</p>
                            </div>
                            <div class="flex flex-col items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-sm md:text-base lg:text-lg">
                                <p>Маркировка мест и упаковочные листы</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <InfoCards :items_group_1="items_group_1" :items_group_2="items_group_2" class="mb-5 md:mb-20" />
        <div class="container">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5 md:mb-20">
                <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                    <h2 class="text-2xl md:text-3xl font-bold mb-5">
                        Снимаем рутину снабжения на объекте
                    </h2>
                    <p class="mb-3">
                        Закрываем подбор по ГОСТ/ТУ, резку в размер, упаковку/маркировку и логистику «до ворот»/на площадку — чтобы монтаж шёл без срывов.
                    </p>
                    <p class="mb-3">
                        Учитываем окна поставок, пропуска, требования ТБ и правила складирования металлопроката.
                    </p>
                    <p class="mb-3">Берём на себя:</p>
                    <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                        <li>подбор профилей и толщин под расчётные нагрузки;</li>
                        <li>резку по картам/чертежам с контролем допусков;</li>
                        <li>комплектовку узлами/этажами и маркировку мест;</li>
                        <li>логистику, погрузку/разгрузку, упаковочные листы.</li>
                    </ul>
                </div>

                <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                    <h2 class="text-2xl md:text-3xl font-bold mb-5">
                        Как начать сотрудничество
                    </h2>
                    <p class="mb-3">
                        Оставьте заявку — подготовим КП под объёмы и график СМР, закрепим персонального менеджера и согласуем SLA поставок.
                    </p>
                    <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                        <li>спецусловия на регулярные закупки и квоты;</li>
                        <li>личный кабинет: онлайн-заказы и статусы отгрузок;</li>
                        <li>полный пакет документов: НДС, ЭДО, возможна отсрочка.</li>
                    </ul>
                    <button
                        @click.prevent="openForm"
                        class="mt-4 flex justify-center items-center text-white md:hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase"
                    >
                        Оставить заявку
                    </button>
                </div>
            </div>
        </div>
        <section class="container">
            <FaqComponent
                title="FAQ для монтажных организаций"
                subtitle="Ключевые условия: ассортимент, резка и комплектовка, доставка на площадку, НДС/ЭДО, фиксация цены и дозаказы."
                :items="faqItems"
                schema-id="schema-installers-faq-jsonld"
            />
        </section>
    </div>
</template>

<style scoped lang="scss">
</style>
